import { render, staticRenderFns } from "./siteOwner.vue?vue&type=template&id=41260755&"
import script from "./siteOwner.vue?vue&type=script&lang=js&"
export * from "./siteOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports